import React, { useState, useEffect } from 'react';
import { Eye, TrendingUp, Calendar, BarChart3 } from 'lucide-react';
import { Card } from '../../atoms/Card';
import { contentsService, type HitCountStats } from '../../../services';

export const StatisticsPage = () => {
  const [hitCountStats, setHitCountStats] = useState<HitCountStats | null>(null);

  useEffect(() => {
    const fetchHitCountStats = async () => {
      try {
        const stats = await contentsService.getHitCountStats();
        setHitCountStats(stats);
      } catch (err) {
        console.error('Failed to fetch hitcount stats:', err);
      }
    };

    fetchHitCountStats();
  }, []);


  return (
    <div className="p-4 sm:p-6 lg:p-8 bg-gradient-to-br from-gray-50 to-white min-h-screen">
      {/* Header Section */}
      <div className="mb-8">
        <div className="flex items-center justify-between mb-2">
          <h1 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
            İstatistikler
          </h1>
        </div>
        <p className="text-gray-600 text-base sm:text-lg">
          İçerik okunma (hitcount) istatistikleri
        </p>
      </div>

      {/* Statistics Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
        <Card title="Günlük Okunma">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-3xl font-bold text-blue-600">
                {hitCountStats?.daily ?? 0}
              </p>
              <p className="text-sm text-gray-600 mt-1">Bugün okunan içerik</p>
            </div>
            <div className="p-3 bg-blue-100 rounded-lg">
              <Calendar className="w-8 h-8 text-blue-600" />
            </div>
          </div>
        </Card>

        <Card title="Haftalık Okunma">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-3xl font-bold text-purple-600">
                {hitCountStats?.weekly ?? 0}
              </p>
              <p className="text-sm text-gray-600 mt-1">Bu hafta okunan içerik</p>
            </div>
            <div className="p-3 bg-purple-100 rounded-lg">
              <TrendingUp className="w-8 h-8 text-purple-600" />
            </div>
          </div>
        </Card>

        <Card title="Aylık Okunma">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-3xl font-bold text-orange-600">
                {hitCountStats?.monthly ?? 0}
              </p>
              <p className="text-sm text-gray-600 mt-1">Bu ay okunan içerik</p>
            </div>
            <div className="p-3 bg-orange-100 rounded-lg">
              <BarChart3 className="w-8 h-8 text-orange-600" />
            </div>
          </div>
        </Card>

        <Card title="Yıllık Okunma">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-3xl font-bold text-green-600">
                {hitCountStats?.yearly ?? 0}
              </p>
              <p className="text-sm text-gray-600 mt-1">Bu yıl okunan içerik</p>
            </div>
            <div className="p-3 bg-green-100 rounded-lg">
              <Eye className="w-8 h-8 text-green-600" />
            </div>
          </div>
        </Card>

        <Card title="Toplam Okunma">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-3xl font-bold text-indigo-600">
                {hitCountStats?.total ?? 0}
              </p>
              <p className="text-sm text-gray-600 mt-1">Tüm zamanlar</p>
            </div>
            <div className="p-3 bg-indigo-100 rounded-lg">
              <BarChart3 className="w-8 h-8 text-indigo-600" />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
